import { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { ErrorMessage } from 'jbc-front/components/presenters/form/ErrorMessage';
import { Label, Required } from 'jbc-front/components/presenters/form/Label';
import { Spacer } from 'jbc-front/components/presenters/Spacer';
import { useSession } from '@/components/SessionProvider';
import { Select } from '@/components/react-hook-form/Select';
import { hasPermission } from '@/utils/permission';
import { Schema } from './schema';
import { HealthCheckRoleOptions, StressCheckRoleOptions, UserManageRoleOptions } from './roleOptions';
import styles from './PermissionForm.scss';

export const PermissionForm: FC = () => {
  const { user } = useSession();
  const {
    formState: { errors }
  } = useFormContext<Schema>();

  return (
    <>
      {hasPermission(user, 'user_manage_edit_stress_check_roles') && (
        <div className={styles.field}>
          <Label>
            ストレスチェック権限
            <Spacer direction="x" size={8} />
            <Required />
          </Label>
          <Spacer direction="y" size={8} />
          <Select name="stressCheckRole" options={StressCheckRoleOptions} menuPosition="fixed" />
          {errors.stressCheckRole?.message && <ErrorMessage>{errors.stressCheckRole.message}</ErrorMessage>}
        </div>
      )}
      {hasPermission(user, 'user_manage_edit_regular_health_checkup_roles') && (
        <div className={styles.field}>
          <Label>
            定期健康診断権限
            <Spacer direction="x" size={8} />
            <Required />
          </Label>
          <Spacer direction="y" size={8} />
          <Select name="healthCheckRole" options={HealthCheckRoleOptions} menuPosition="fixed" />
          {errors.healthCheckRole?.message && <ErrorMessage>{errors.healthCheckRole.message}</ErrorMessage>}
        </div>
      )}
      {hasPermission(user, 'user_manage_edit_user_manage_roles') && (
        <div className={styles.field}>
          <Label>
            管理者追加・削除
            <Spacer direction="x" size={8} />
            <Required />
          </Label>
          <Spacer direction="y" size={8} />
          <Select name="userManageRole" options={UserManageRoleOptions} menuPosition="fixed" />
          {errors.userManageRole?.message && <ErrorMessage>{errors.userManageRole.message}</ErrorMessage>}
        </div>
      )}
    </>
  );
};
